import { PhoneIncoming, PhoneOutgoing, Smartphone, Globe, CalendarSync, Languages, BarChart3, MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

const ICONS = [PhoneIncoming, PhoneOutgoing, Smartphone, Globe, CalendarSync, Languages, BarChart3, MessageCircle];
const SPANS = [
  "md:col-span-8", "md:col-span-4",
  "md:col-span-4", "md:col-span-8",
  "md:col-span-3", "md:col-span-3", "md:col-span-3", "md:col-span-3",
];

export const BentoGrid = () => {
  const { t } = useLang();
  return (
    <section id="whats-included" data-testid="whats-included-section" className="relative py-24 sm:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-[50rem] -translate-x-1/2 rounded-full bg-cyan-500/5 blur-[110px]" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <p className="font-mono2 text-xs uppercase tracking-[0.28em] text-cyan-400">{t.included.kicker}</p>
          <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            {t.included.title}
          </h2>
          <p className="mt-4 text-base text-slate-400 sm:text-lg">{t.included.sub}</p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-12">
          {t.included.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 0.06} className={`col-span-full ${SPANS[i]}`}>
                <div
                  data-testid={`bento-item-${i}`}
                  className="glass group relative h-full overflow-hidden rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/35 hover:shadow-[0_20px_60px_rgba(16,185,129,0.12)]"
                >
                  <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-emerald-500/5 blur-2xl transition-opacity duration-300 group-hover:bg-emerald-500/15" />
                  <div className="flex items-start justify-between gap-4">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-700/70 bg-slate-900/70 transition-colors group-hover:border-emerald-500/40">
                      <Icon className="h-5 w-5 text-emerald-400" />
                    </span>
                    <span className="rounded-full border border-slate-700/70 px-2.5 py-1 font-mono2 text-[9px] uppercase tracking-[0.18em] text-slate-400">
                      {item.badge}
                    </span>
                  </div>
                  <h3 className="font-display mt-5 text-lg font-bold tracking-tight text-slate-100">
                    {item.name}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
